"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Footer;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _InfoOutlined = _interopRequireDefault(require("@material-ui/icons/InfoOutlined"));
var _contexts = require("../../../contexts");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Contexts

// Styles

function Footer() {
  var {
    currentLocation,
    totalLocation,
    currentPercentage,
    loadingLocations,
    currentEndLocation
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  var {
    backgroundStyle
  } = (0, _react.useContext)(_contexts.ReaderPreferencesContext);
  var classes = (0, _styles.default)();
  var renderLabel = () => {
    if (loadingLocations) {
      return /*#__PURE__*/_react.default.createElement("span", null, "Carregando...");
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, currentLocation === currentEndLocation ? currentLocation : "".concat(currentLocation, "-").concat(currentEndLocation), ' / ', totalLocation, ' ', "(", currentPercentage, "%)");
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: backgroundStyle === 'dark' ? '#BDBDBD' : '#616161'
    }
  }, renderLabel()), /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_InfoOutlined.default, {
      fontSize: "medium",
      classes: {
        root: classes.internalTooltipIcon
      }
    }), "A BDS utiliza um sistema de pagina\xE7\xE3o por n\xFAmero de caracteres. Por isso, voc\xEA pode estar visualizando mais de uma p\xE1gina por tela."),
    placement: "top-start",
    classes: {
      tooltip: classes.tooltip
    }
  }, /*#__PURE__*/_react.default.createElement(_InfoOutlined.default, {
    fontSize: "medium",
    color: "primary",
    classes: {
      root: "".concat(classes.tooltipIcon, " ").concat(backgroundStyle === 'dark' ? classes.tooltipIconDarkMode : classes.tooltipIconLightMode)
    }
  }))));
}